/**
 * Lab page for the mesh-sync R&D — wraps MeshInstructor so it has a
 * dedicated route (/lab/mesh-instructor) without polluting any
 * production surfaces. Uses default export for the route, named
 * export from MeshInstructor.
 */
import MeshInstructor from "@/components/MeshInstructor";

export default function LabMeshInstructor() {
  return <MeshInstructor />;
}
